// Conditional exports - only export if libraries are available
let AnimatedBackground, WebGLScene;

try {
  AnimatedBackground = require('./AnimatedBackground').default;
  WebGLScene = require('./Scene').default;
} catch (e) {
  // Fallback components if WebGL libraries aren't available
  AnimatedBackground = () => null;
  WebGLScene = () => null;
}

export { AnimatedBackground, WebGLScene };
